module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg1-70fef9e8853765e398fa77ace0bdfb96.png";